module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W. Adolphe Roberts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("W. Adolphe Roberts was a Jamaican-born novelist, poet, and historian. Roberts served as a war correspondent during World War I, after which he acted as the editor of multiple periodicals including "), _c('I', [_vm._v("Ainslee’s Magazine")]), _vm._v(", and authored more than a dozen books. He died in 1962."), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19qxDAi/tc-custom/9781504093132.jpg?1737543861965",
      "alt": "This image is the cover for the book Haunting Hand, Otto Penzler's Locked Room Library"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunting Hand, Otto Penzler's Locked Room Library\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An actress stars in her own off-screen mystery in this Golden Age whodunit from the award-winning Jamaican novelist, poet, and historian.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Though originally a medical student specializing in chemistry, twenty-five-year-old Margot Anstruther decides to try her luck as an actress and gets cast in her first role for the Superfilm Company. With the studio’s boorish director taking a personal interest in her, Margot finds herself caught in the middle of two men: her boss and her increasingly jealous suitor, Gene Varley."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" One night, alone in her midtown Manhattan apartment after a party, Margot is shocked to find a hand reaching out from under her bed. Though Gene and the police find no sign of an intruder, Margot refuses to believe in a supernatural cause. She puts her scientific mind to work delving into her apartment’s strange past—a recent tenants’ disappearance—and walking a fine line between the complicated passions of friends and rivals . . ."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    MysteriousPress.com/Open Road Integrated Media, Inc.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0